export default __webpack_public_path__ + "static/media/planche.da193a00.jpg";